{
	"hero": {
		"title": "Pick a plan that matches your pace",
		"subtitle": "AI notes, flashcards, quizzes and tutor — all in one"
	},
	"cycle": {
		"monthly": "Monthly",
		"annual": "Annual",
		"save": "−{percent}%",
		"annualNote": "billed annually"
	},
	"currency": {
		"label": "Currency",
		"rub": "RUB",
		"usd": "USD",
		"eur": "EUR"
	},
	"tiers": {
		"free": {
			"name": "Free",
			"tagline": "Free forever",
			"period": "forever",
			"features": [
				"5 materials",
				"3 notes per day",
				"20 tutor messages",
				"50 flashcards / 2 quizzes per day",
				"60 minutes recording / month",
				"2 audio recaps / month"
			]
		},
		"plus": {
			"name": "Plus",
			"tagline": "Popular",
			"popular": "Popular",
			"period": "/mo",
			"features": [
				"100 materials",
				"50 notes per day",
				"500 tutor messages",
				"20 flashcards / 20 quizzes per day",
				"600 minutes recording / month",
				"20 audio recaps / month",
				"Voice Tutor — 60 min",
				"Essays — 10 / month"
			]
		},
		"pro": {
			"name": "Pro",
			"tagline": "Maximum",
			"period": "/mo",
			"features": [
				"Unlimited materials",
				"Unlimited AI generations",
				"Unlimited tutor messages",
				"Unlimited recordings",
				"Unlimited audio recaps",
				"Voice Tutor — 300 min",
				"Visual explanations from photos and graphs",
				"Essays with inline annotations",
				"Priority queue"
			]
		}
	},
	"cta": {
		"guest": "Start free",
		"free": "Start 14-day Plus",
		"trial": "Trial active",
		"current": "Current plan",
		"upgrade": "Upgrade to {tier}",
		"downgrade": "Downgrade to {tier}",
		"restore": "Restore"
	},
	"comparison": {
		"title": "Feature comparison",
		"feature": "Feature",
		"rows": {
			"materials": "Materials (total)",
			"notesDaily": "Notes per day",
			"cardsDaily": "Flashcards per day",
			"quizzesDaily": "Quizzes per day",
			"tutorDaily": "Tutor messages per day",
			"recordingMinutes": "Recording (min / month)",
			"audioRecaps": "Audio recaps per month",
			"essays": "Essays per month",
			"voiceTutor": "Voice Tutor (min / month)",
			"priority": "Priority queue"
		}
	},
	"faq": {
		"title": "Frequently asked questions",
		"items": {
			"cancel": {
				"q": "Can I cancel anytime?",
				"a": "Yes. Cancel anytime from profile settings. Access to Plus/Pro features remains until the end of the paid period."
			},
			"trial": {
				"q": "What happens after the trial?",
				"a": "After the 14-day trial without an active subscription you fall back to the Free tier. No charge happens without explicit confirmation."
			},
			"payments": {
				"q": "Which payment methods are available?",
				"a": "Cards, popular local payment methods and PayPal — the set of available options adapts to your region."
			},
			"refund": {
				"q": "What if AI generation fails?",
				"a": "If AI failed during generation — we refund the consumed quota. For system errors — full money refund."
			},
			"money": {
				"q": "Can I get a refund?",
				"a": "Within 14 days of purchase — yes, by reaching out to support."
			}
		}
	},
	"finalCta": {
		"title": "Ready to start?",
		"button": "Start 14-day"
	},
	"footer": {
		"terms": "Terms",
		"privacy": "Privacy",
		"contacts": "Contacts"
	},
	"error": {
		"title": "Failed to load pricing",
		"retry": "Try again"
	}
}
